import isEmpty from 'lodash-es/isEmpty'
import mapValues from 'lodash-es/mapValues'
import omit from 'lodash-es/omit'

import { BIRDVIEW_SCOPE_INDEPENDENT_SECTIONS } from '../../DashboardBirdview.constants'
import { getBirdviewRequestKey } from '../../DashboardBirdview.utils.sections'

function getSectionKeyParams(key, params) {
  return BIRDVIEW_SCOPE_INDEPENDENT_SECTIONS.includes(key)
    ? omit(params, 'scope')
    : params
}

export function checkIsDashboardBirdviewFirstLoad(results) {
  return isEmpty(results)
}

export function getDashboardBirdviewSectionParams({
  key,
  params,
  sectionParams,
}) {
  return { ...params, ...sectionParams[key] }
}

export function getDashboardBirdviewRequestKeys({
  getters,
  params,
  reloadTokens,
  sectionParams,
}) {
  return mapValues(getters, (_, key) =>
    getBirdviewRequestKey(
      getSectionKeyParams(
        key,
        getDashboardBirdviewSectionParams({ key, params, sectionParams })
      ),
      `${key}${reloadTokens[key] ?? 0}`
    )
  )
}

export function getDashboardBirdviewRequestKeysSignature(requestKeys) {
  return Object.values(requestKeys).join()
}

export function getDashboardBirdviewPendingRequestKeys(
  requestKeys,
  latestRequestKeys
) {
  return Object.entries(requestKeys).filter(
    ([key, requestKey]) => latestRequestKeys[key] !== requestKey
  )
}

export function getDashboardBirdviewSections({
  requestKeys,
  results,
  onReloadSection,
}) {
  return mapValues(requestKeys, (requestKey, key) => {
    const result = results[key]
    const isLoading = result?.requestKey !== requestKey
    const isRefreshing = isLoading && Boolean(result?.data)

    return {
      data: isLoading && !isRefreshing ? null : result.data,
      hasError: !isLoading && result.hasError,
      isLoading,
      isRefreshing,
      reload: () => onReloadSection(key),
    }
  })
}
